// extracted by mini-css-extract-plugin
module.exports = {"component":"DungeonCategoryTitle_component__2BDUh","titleText":"DungeonCategoryTitle_titleText__3tFuy"};